export default "__VITE_ASSET__JZP61Fas__"